module.exports = __webpack_public_path__ + "img/15.36814af8.svg";